import { render, staticRenderFns } from "./ChangeOrderModal.vue?vue&type=template&id=008495e4&"
import script from "./ChangeOrderModal.vue?vue&type=script&lang=js&"
export * from "./ChangeOrderModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports